import React from 'react';

import GrayButtonComponent from '@/components/common/elements/GrayButton/GrayButtonComponent';

const GrayButtonContainer = ({ ...props }) => {
  return <GrayButtonComponent {...props} />;
};

export default GrayButtonContainer;
